import React from 'react';
import AccountSettingsService from '../../services/account-settings.service';
import ProjectsService from '../../services/projects.service';
import UserInvestmentService from '../../services/user-investment.service';
import { useState, useEffect, useRef } from 'react';
import { Spinner, Alert } from '../../services/notiflix.service';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Sliderify } from 'react-sliderify';
import TransactionService from '../../services/transaction.service';
import { useSelector, useDispatch } from 'react-redux';
import EsignaturePop from '../../components/common/EsignaturesPop';
import PayoutService from '../../services/payout.service';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-tooltip/dist/react-tooltip.css';
import ConfirmationModal from '../../components/common/ConfirmationModal';
import PlatformWalletConnection from '../../components/common/PlatformWalletConnection';
import VerificationFailed from '../../components/common/VerificationFailed';
import VouchersService from '../../services/vouchers.service';
import { ContactMeModal } from '../../components/common/ContactMeModal';
import {
  LeftArrowIcon,
  BrownClockRunningIcon,
  BrownCrossIcon,
  LocationIcon,
  CloseButtonSvgIcon,
  QuestInriscSvgIcon,
  QuestIsinSvgIcon,
  QuestNominalSvgIcon,
  QuestPriceSvgIcon,
  QuestAnnualInterestSvgIcon,
  QuestAnnualYieldSvgIcon,
  QuestRepaymentSvgIcon,
  SoldOutSvgIcon,
  DownloadSvgIcon,
  OpenNewTabIcon,
  SoldOutDutchSvgIcon,
  RepaidListingSvgIcon,
} from '../../components/common/IconProvider';
import UpcomingPayoutList from './UpcomingPayoutList';
import MDEditor from '@uiw/react-md-editor';
import {
  calculateDiscountAmount,
  calculateEnergyCapacity,
  calculateLifeSpanDifference,
  formatDate,
  formatNumber,
  formatWithEllipsis,
} from '../../utils/Helper';
import ImageLoader from '../../components/common/ImageLoader';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import TableComponent from '../../components/common/TableComponent';
import { useTranslation } from 'react-i18next';
import KycVerification from '../../components/KycVerification';
import BankTransferModal from '../../components/common/BankTransferModal';
import { setBankTransfer } from '../../actions/bankTransfer';
const ProjectDetails = () => {
  const { user: _authUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const language = useSelector((state) => state.languageReducer.language);
  const { selectedTransaction } = useSelector(
    (state) => state.bankTransferReducer,
  );
  const { wallet } = useSelector((state) => state.wallet);
  const Navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const checkInterval = useRef();
  const checkPaymentStatusInterval = useRef();
  const { orderId } = useParams();
  const [isOpenAggrement, setIsOpenAggrement] = useState(false);
  const [isPayoutLoader, setPayoutLoader] = useState(false);
  const [isOnchainLoader, setOnchainLoader] = useState(false);
  const [isTotalPaidDividendAmount, setTotalPaidDividendAmount] = useState(0);
  const [isNftBuyErrorMsg, setNftBuyErrorMsg] = useState(null);
  const [projectDetails, setProjectDetails] = useState(null);
  const [projectDetailsLoading, setProjectDetailsLoading] = useState(true);
  const [isTransactionPop, setTransactionPop] = useState(false);
  const [isContactUSPop, setContactUSPop] = useState({
    open: false,
    quantity: 0,
    paymentMethod: '',
  });
  const [showThankYouPopup, setShowThankYouPopup] = useState(false);
  const [isNftQuantity, setNftQuantity] = useState(0);
  const [isTotalAmount, setTotalAmount] = useState(0);
  const [isPaymentMethod, setPaymentMethod] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [userPayoutList, setUserPayoutList] = useState([]);
  const [isAgreementType, setAgreementType] = useState(null);
  const [showModalKYC, setShowModalKYC] = useState(false);
  const [AvailableQty, setAvailableQty] = useState(0);
  const [isNftTransferStatus, setNftTransferStatus] = useState(false);
  const [IsProjectAgreement, setIsProjectAgreement] = useState(false);
  const [showPlatformAgreement, setPlatformAgreement] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [isSignedPltformAgreement, setSignedPltformAgreement] = useState(false);
  const [isWalletExist, setIsWalletExist] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [kycFailedReasons, setKycFailedReasons] = useState([]);
  const [voucherException, setVoucherException] = useState('');
  const [voucherCode, setVoucherCode] = useState('');
  const [haveVoucher, setHaveVoucher] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [voucherCodeDetails, setVoucherCodeDetails] = useState('');
  const [shouldCallApi, setShouldCallApi] = useState(false);
  const [voucherDetailsLoader, setvoucherDetailsLoader] = useState(false);
  const [isSortingLoader, setSortingLoader] = useState(false);
  const [filterOnChainData, setFilterOnChainData] = useState({
    perPage: 5,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: id,
  });
  const [filterPayoutData, setFilterPayoutData] = useState({
    perPage: 5,
    page: 1,
    commonSearch: '',
    sortBy: '',
    project_id: id,
  });

  const [isPagination, setPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });

  const [receivedPayoutPagination, setReceivedPayoutPagination] = useState({
    totalPages: 5,
    currentPage: 1,
  });

  const [onChainTransactionLists, setOnChainTransactionList] = useState([]);

  const [formattedPrice, setFormattedPrice] = useState('');
  const [showBankTransferModal, setShowBankTransferModal] = useState(false);
  useEffect(() => {
    getProjectsDetails(true);
  }, [isSignedPltformAgreement]);

  useEffect(() => {
    return () => {
      if (checkInterval.current) {
        clearInterval(checkInterval.current);
        checkInterval.current = undefined;
      }
    };
  }, []);

  const checkAgrementStatus = async () => {
    if (_authUser.platform_agreement_status !== 1) {
      setPlatformAgreement(true);
      setAgreementType('platform');
      setIsOpenAggrement(false);
      return false;
    }
    if (
      projectDetails?.investment_type === 'bond' &&
      IsProjectAgreement === false
    ) {
      if (projectDetails?.userAgreement?.length > 0) {
        var res = projectDetails.userAgreement.filter(
          (v) => v.agreement_status === 1,
        );

        if (res?.length === 0) {
          /* show esignature modal */
          setPlatformAgreement(true);
          setAgreementType('project');
          setIsOpenAggrement(false);
          return false;
        }
      } else {
        /* show esignature modal */
        setPlatformAgreement(true);
        setAgreementType('project');
        setIsOpenAggrement(false);
        return false;
      }
    }

    if (_authUser.bank_details === false) {
      setConfirmAction(true);
      setIsOpenAggrement(false);
      return false;
    }

    // redirected to payment URL
    paymentRequest();
  };

  useEffect(() => {
    isOpenAggrement && checkAgrementStatus();
  }, [isOpenAggrement]);

  const getProjectsDetails = async (loader = false) => {
    if (loader) {
      setProjectDetailsLoading(true);
    }
    let slugType = location.pathname.includes('owned-assets');
    let slug = null;
    if (slugType) {
      slug = 'owned-assets';
    } else {
      slug = 'project';
    }

    try {
      let resp = await ProjectsService.details(id, slug);
      setProjectDetailsLoading(false);
      if (resp.status === 'failure') {
        Alert.error(resp.message);
        if (resp.message === 'Project does not exists.') {
          if (slug === 'owned-assets') {
            Navigate('/owned-assets');
          } else {
            Navigate('/assets');
          }
          return false;
        }
        return false;
      }
      setProjectDetails(resp?.data);

      // set price with formatting
      const price = Number(resp?.data.price) || 0;

      setFormattedPrice(price);

      setAvailableQty(parseInt(Number(resp?.data?.available_qty)));

      setNftTransferStatus(resp?.data.nft_transfer_status);
      // onChainTransactionList();
      // getUserPayoutList();
    } catch (error) {
      setProjectDetailsLoading(false);
      Alert.error(error.message);
      return false;
    }
  };

  const trackPaymentStatus = async () => {
    setTransactionPop(true);
    try {
      const formData = {
        order_id: orderId,
      };
      let projectListRes =
        await UserInvestmentService.trackPaymentStatus(formData);
      if (projectListRes.status === 'failure') {
        Alert.error(projectListRes.message);
        return false;
      }

      setPaymentStatus(projectListRes.data);
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const onChainTransactionList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setOnchainLoader(true); // Show pagination loader
      }
      const { currentPage } = pagination;
      const { field, order } = sorting;
      let projectListRes = await TransactionService.onChainList(
        filterOnChainData.perPage,
        currentPage,
        filterOnChainData.commonSearch,
        filterOnChainData.sortBy,
        filterOnChainData.project_id,
        '',
        field,
        order,
        '',
      );
      if (projectListRes.status === 'failure') {
        setOnchainLoader(false);
        setSortingLoader(false);
        Alert.error(projectListRes.message);
        return false;
      }

      setOnChainTransactionList(projectListRes.data.records);

      setPagination({
        totalPages: projectListRes.data.pagination.totalPages,
        currentPage: projectListRes.data.pagination.page,
      });
      setOnchainLoader(false);
      setSortingLoader(false);
      setNftTransferStatus(!projectListRes.data.is_nft_transfered);
      if (!projectListRes.data.is_nft_transfered) {
        if (checkInterval.current === undefined) {
          checkInterval.current = setInterval(onChainTransactionList, 5000);
        }
      } else {
        checkInterval.current && clearInterval(checkInterval.current);
        checkInterval.current = undefined;
      }
    } catch (error) {
      setOnchainLoader(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };
  let checkoutUrl1 = '/assets/payment/checkout/';
  useEffect(() => {
    if (location.pathname.includes(checkoutUrl1)) {
      trackPaymentStatus();
    }
  }, []);

  useEffect(() => {
    if (location.state?.openKycModal) {
      setShowModalKYC(true);
    }
    if (location.state?.quantity) {
      setNftQuantity(location.state?.quantity);
    }
  }, [location]);

  useEffect(() => {
    if (location.pathname.includes(checkoutUrl1)) {
      if (isTransactionPop === false) {
        checkPaymentStatusInterval.current &&
          clearInterval(checkPaymentStatusInterval.current);
        checkPaymentStatusInterval.current = undefined;
      } else {
        if (paymentStatus && paymentStatus.status === 'pending') {
          if (checkPaymentStatusInterval.current === undefined) {
            checkPaymentStatusInterval.current = setInterval(
              trackPaymentStatus,
              5000,
            );
          }
        } else {
          checkPaymentStatusInterval.current &&
            clearInterval(checkPaymentStatusInterval.current);
          checkPaymentStatusInterval.current = undefined;
        }
      }
    } else {
      checkPaymentStatusInterval.current &&
        clearInterval(checkPaymentStatusInterval.current);
      checkPaymentStatusInterval.current = undefined;
    }
  }, [isTransactionPop, paymentStatus]);

  useEffect(() => {
    if (location.state?.openPaymentDetailsModal) {
      setShowBankTransferModal(true);
      Navigate(location.pathname, { replace: true });
    }
  }, [location.state]);

  const { t } = useTranslation(['projectDetails', 'common']);
  const paymentRequest = async () => {
    try {
      const resValidate = await validateRequest(false, false, null);

      if (resValidate) {
        const formData = {
          project_id: projectDetails.id,
          payment_method: isPaymentMethod,
          quantity: isNftQuantity,
          voucher_code: voucherCodeDetails
            ? voucherCodeDetails?.voucher_code
            : null,
          wallet_address: wallet?.walletAddress ? wallet?.walletAddress : null,
          orderId: orderId,
        };

        Spinner.show();
        if (isPaymentMethod === 'banktransfer') {
          let paymentRes =
            await UserInvestmentService.createPaymentRequest(formData);
          if (paymentRes.status === 'failure') {
            Spinner.hide();
            Alert.error(paymentRes.message);
            return false;
          }
          const orderId = paymentRes.data.order_id;
          const mollieRes = await UserInvestmentService.getMolliePaymentDetails(
            {
              order_id: orderId,
            },
          );
          if (mollieRes?.status === 'failure') {
            Spinner.hide();
            Alert.error(mollieRes?.message);
            return false;
          }
          dispatch(
            setBankTransfer({
              order_id: orderId,
              amount: mollieRes.data?.amount?.value,
              bankAccount: mollieRes.data?.consumerAccount?.bankAccount,
              bankName: mollieRes.data?.consumerAccount?.bankName,
              paymentReference:
                mollieRes.data?.consumerAccount?.transferReference,
              expiryDate: mollieRes.data?.expiryDate,
              project_id: projectDetails?.id,
              projectName: projectDetails?.name,
            }),
          );
          setShowBankTransferModal(true);
          Spinner.hide();
        } else {
          let paymentRes =
            await UserInvestmentService.createPaymentRequest(formData);
          if (paymentRes.status === 'failure') {
            Spinner.hide();
            Alert.error(paymentRes.message);
            return false;
          }
          window.open(paymentRes.data.paymentUrl, '_self');
        }
      }
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };
  const validateRequest = async (_projectsAgreementStatus = false) => {
    try {
      var ans = isNftQuantity.toString().includes('.') ? true : false;

      if (ans) {
        setNftBuyErrorMsg(
          `${projectDetails?.investment_type === 'bond' ? 'Bond' : 'Token'} ${t(
            'valid_number_no_decimal',
          )}`,
        );
        return false;
      }
      if (parseInt(isNftQuantity) > AvailableQty) {
        setNftBuyErrorMsg(t('purchase_limit_exceeded'));
        return false;
      }
      if (isNftQuantity < 1) {
        setNftBuyErrorMsg(
          t('token_quantity_minimum', {
            token:
              projectDetails?.investment_type === 'bond' ? 'bond' : 'token',
          }),
        );
        return false;
      }

      /* tokens purchase limitation */

      //get the total owned nft of user
      let totalOwnedQty = projectDetails?.user_total_quantity
        ? projectDetails?.user_total_quantity
        : 0;
      let pendingToPurchase =
        projectDetails.purchaseCriteria.maxPurchaseLimit - totalOwnedQty;
      // case 1
      if (projectDetails?.investment_type === 'asset') {
        if (totalOwnedQty >= projectDetails.purchaseCriteria.maxPurchaseLimit) {
          setNftBuyErrorMsg(t('max_purchase_limit_exceeded'));
          return false;
        }
      }
      //case 2
      if (projectDetails?.investment_type === 'asset') {
        if (isNftQuantity > pendingToPurchase) {
          setNftBuyErrorMsg(
            `You are only allowed to buy ${pendingToPurchase} ${
              totalOwnedQty !== 0 ? 'more' : ''
            } tokens`,
          );
          return false;
        }
      }
      /* -------- */

      if (
        (isTotalAmount < discountAmount || isTotalAmount > discountAmount) &&
        !isPaymentMethod
      ) {
        setNftBuyErrorMsg(t('select_payment_method'));
        return false;
      }

      if (_authUser.bank_details === false) {
        setConfirmAction(true);
        return false;
      }

      if (
        _authUser.kyc_status === 0 ||
        _authUser.kyc_status === 2 ||
        _authUser.kyc_status === 3
      ) {
        setShowModalKYC(true);
        return false;
      }

      if (_authUser.kyc_status === 4) {
        getProfileDetails();
        setShowReviewModal(true);
        return false;
      }

      if (_authUser.platform_agreement_status !== 1) {
        if (!_projectsAgreementStatus) {
          setPlatformAgreement(true);
          setAgreementType('platform');
          return false;
        }
      }

      if (
        projectDetails?.investment_type === 'bond' &&
        IsProjectAgreement === false
      ) {
        if (projectDetails?.userAgreement?.length > 0) {
          var res = projectDetails.userAgreement.filter((v) => {
            return v.agreement_status === 1;
          });
          if (res?.length === 0) {
            /* show esignature modal */
            setPlatformAgreement(true);
            setAgreementType('project');
            return false;
          }
        } else {
          /* show esignature modal */
          setPlatformAgreement(true);
          setAgreementType('project');
          return false;
        }
      }

      if (_authUser.bank_details === false) {
        setConfirmAction(true);
        return false;
      }
      return true;
    } catch (error) {
      Alert.error(error.message);
      return false;
    }
  };

  const getProfileDetails = async () => {
    try {
      let resp = await AccountSettingsService.details();
      if (resp.status === 'failure') {
        Alert.error(resp.message);
        return false;
      }

      if (resp?.data?.KycReport && resp?.data?.KycReport?.length > 0) {
        const rawReasons = resp.data.kycReports[0]?.reasons;

        try {
          const parsedReasons = JSON.parse(rawReasons);
          const moderationComment = parsedReasons.moderationComment || '';

          const reasons = moderationComment
            .split('\n')
            .filter((line) => line.trim() !== '') // remove empty lines
            .slice(0, 3); // get first 3

          setKycFailedReasons(reasons);
        } catch (error) {
          Alert.error(error.message);
          setKycFailedReasons([]);
        }
      }
    } catch (error) {
      Alert.error(error.message);
    }
  };

  const addBankDetails = () => {
    Navigate('/profile', {
      state: { id, quantity: isNftQuantity, slug: 'bankDetail' },
    });
  };

  const closeModal = () => {
    setConfirmAction(false);
    setIsWalletExist(false);
  };

  const NFTquantity = async (e) => {
    let value = e ? e : 0;
    setNftQuantity(value);
    setDiscountAmount(0);
    var ans = value.toString().includes('.') ? true : false;
    if (ans) {
      setNftBuyErrorMsg(t('invalid_token_count'));
      return false;
    }
    if (projectDetails?.investment_type === 'asset') {
      if (parseInt(value) > AvailableQty) {
        setNftBuyErrorMsg(t('token_quantity_exceeds_available'));
        return false;
      }
    }
    let minPurchaseQnty = 1;
    if (
      projectDetails?.investment_type === 'bond' &&
      !projectDetails?.hasPreviousInvestments &&
      projectDetails?.min_purchase_qty !== '0'
    ) {
      minPurchaseQnty = projectDetails?.min_purchase_qty
        ? projectDetails?.min_purchase_qty
        : 1;
    }

    if (value <= 0) {
      setNftBuyErrorMsg(
        t('token_quantity_minimum', {
          token: projectDetails?.investment_type === 'bond' ? 'bond' : 'token',
          minPurchaseQnty,
        }),
      );
      setTotalAmount(0);
      return false;
    }

    let isVoucherCodeApplied = voucherCodeDetails
      ? voucherCodeDetails?.voucher_code
      : null;

    if (
      projectDetails?.investment_type === 'bond' &&
      value < Number(projectDetails?.min_purchase_qty) &&
      !projectDetails?.hasPreviousInvestments &&
      !isVoucherCodeApplied
    ) {
      setNftBuyErrorMsg(
        t('min_purchase_validation') + ' ' + projectDetails?.min_purchase_qty,
      );
      return false;
    }
    let price =
      projectDetails?.price > 0
        ? projectDetails?.price
        : projectDetails?.nominal_value;

    let totalAmount = value * price;

    setTotalAmount(totalAmount.toFixed(2));

    let noOfTokens = totalAmount / price;
    let discountAmount = 0;
    discountAmount = calculateDiscountAmount(
      voucherCodeDetails?.totalRemainToken || 0,
      noOfTokens,
      price,
    );
    setDiscountAmount(discountAmount);
  };

  const handlePagination = (current, type) => {
    if (type === 'transation') {
      setPagination({ ...isPagination, currentPage: current });
      setFilterOnChainData({
        ...filterOnChainData,
        page: current,
      });
    } else if (type === 'payout') {
      setReceivedPayoutPagination({
        ...receivedPayoutPagination,
        currentPage: current,
      });
      setFilterPayoutData({
        ...filterPayoutData,
        page: current,
      });
    }
  };

  useEffect(() => {
    onChainTransactionList();
  }, [filterOnChainData]);

  useEffect(() => {
    getUserPayoutList();
  }, [filterPayoutData]);

  const modelClose = async () => {
    setShowModalKYC(false);
    setPlatformAgreement(false);
    if (projectDetails?.investment_type === 'bond') {
      setIsProjectAgreement(false);
    }
  };
  const docsignPopOpen = async () => {
    setShowModalKYC(false);
    if (_authUser?.platform_agreement_status !== 1) {
      setPlatformAgreement(true);
      setAgreementType('platform');
      return false;
    }
  };
  const declineModelClose = async () => {
    setShowModalKYC(false);
    setPlatformAgreement(false);
  };
  const paymentSuccessRedirect = (project_id) => {
    setTransactionPop(false);
    Navigate('/owned-assets/details/' + project_id);
  };

  const handleCloseThankYouPopup = () => {
    setShowThankYouPopup(false);
    setNftQuantity('');
    setPaymentMethod('');
    setContactUSPop({ open: false, quantity: 0, paymentMethod: '' });
  };

  useEffect(() => {
    if (location?.state?.openContactPopup) {
      setContactUSPop({
        open: true,
        quantity: location.state?.quantity || '',
        paymentMethod: location.state?.paymentMethod || '',
      });
    }
    // Clear the state so it won't be available on reload
    Navigate(location.pathname, { replace: true });
  }, []);

  useEffect(() => {
    if (
      projectDetails?.professional_investors_only &&
      (!isNftQuantity || isNftQuantity === '')
    ) {
      NFTquantity(20);
    }
  }, [projectDetails]);

  const getUserPayoutList = async (
    pagination = { currentPage: 1 },
    sorting = { field: '', order: '' },
    isSorting = false,
  ) => {
    try {
      //call fiat transaction api
      if (isSorting) {
        setSortingLoader(true); // Show sorting loader
      } else {
        setPayoutLoader(true); // Show pagination loader
      }

      const { currentPage } = pagination;
      const { field, order } = sorting;
      let fiatResponse = await PayoutService.getUserPayoutList(
        filterPayoutData.perPage,
        currentPage,
        filterPayoutData.commonSearch,
        filterPayoutData.project_id,
        filterPayoutData.user_id,
        filterPayoutData.payout_id,
        field,
        order,
      );
      if (fiatResponse.status === 'failure') {
        setPayoutLoader(false);
        setSortingLoader(false);
        Alert.error(fiatResponse.message);
        return false;
      }

      setPayoutLoader(false);
      setSortingLoader(false);
      setUserPayoutList([...fiatResponse.data.records]);
      setTotalPaidDividendAmount(fiatResponse.data.total_paid_payout_amount);
      setReceivedPayoutPagination({
        totalPages: fiatResponse.data.pagination.totalPages,
        currentPage: fiatResponse.data.pagination.page,
      });
    } catch (error) {
      setPayoutLoader(false);
      setSortingLoader(false);
      Alert.error(error.message);
      return false;
    }
  };

  const clearVoucher = () => {
    setVoucherException('');
    setDiscountAmount(0);
    setVoucherCodeDetails('');
    setVoucherCode('');
    setHaveVoucher(false);
    setNftBuyErrorMsg('');
  };

  useEffect(() => {
    if (shouldCallApi) {
      const delayDebounceFn = setTimeout(() => {
        getvoucherDetails();
        // Reset shouldCallApi after calling the API
        setShouldCallApi(false);
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    }
  }, [shouldCallApi, voucherCode]);

  const handleVoucherChange = async (value) => {
    setVoucherCode(value.toUpperCase());
    if (value?.length <= 3) {
      return false;
    }
    setShouldCallApi(true);
  };

  const getvoucherDetails = async () => {
    try {
      setvoucherDetailsLoader(true);
      const resp = await VouchersService.details({
        voucher_code: voucherCode,
        project_id: id,
        user_id: _authUser.userId,
      });
      if (resp.status === 'failure') {
        setVoucherException(resp.message);
        setVoucherCodeDetails('');
        setDiscountAmount(0);
        setvoucherDetailsLoader(false);
        return false;
      }

      setVoucherCodeDetails(resp?.data);
      setVoucherException('');
      setvoucherDetailsLoader(false);
      if (isTotalAmount === 0) {
        return false;
      }
      let price =
        projectDetails?.price > 0
          ? projectDetails?.price
          : projectDetails?.nominal_value;
      let noOfTokens = isTotalAmount / price;
      let discountAmount = 0;

      discountAmount = calculateDiscountAmount(
        resp?.data.totalRemainToken,
        noOfTokens,
        price,
      );
      setDiscountAmount(discountAmount);
    } catch (error) {
      Alert.error(error.message);
    }
  };
  const refreshInvestInput = () => {
    setNftQuantity(0);
    setVoucherCode('');
    setPaymentMethod('');
  };
  return (
    <>
      <div>
        <div className="md:pl-4 pb-4">
          {isNftTransferStatus && (
            <NftTransferStatusPopup
              onClose={() => setNftTransferStatus(false)}
            />
          )}
          <div className="grid gap-5 grid-cols-12 ">
            <ProjectInfo
              projectDetailsLoading={projectDetailsLoading}
              projectDetails={projectDetails}
              AvailableQty={AvailableQty}
              Navigate={Navigate}
              isTotalPaidDividendAmount={isTotalPaidDividendAmount}
              language={language}
            />

            <FactsheetComponent
              projectDetails={projectDetails}
              AvailableQty={AvailableQty}
              projectDetailsLoading={projectDetailsLoading}
              discountAmount={discountAmount}
              formattedPrice={formattedPrice}
              setNftBuyErrorMsg={setNftBuyErrorMsg}
              NFTquantity={NFTquantity}
              isNftQuantity={isNftQuantity}
              setPaymentMethod={setPaymentMethod}
              isTotalAmount={isTotalAmount}
              isPaymentMethod={isPaymentMethod}
              isNftBuyErrorMsg={isNftBuyErrorMsg}
              haveVoucher={haveVoucher}
              setHaveVoucher={setHaveVoucher}
              handleVoucherChange={handleVoucherChange}
              clearVoucher={clearVoucher}
              voucherDetailsLoader={voucherDetailsLoader}
              voucherCode={voucherCode}
              voucherException={voucherException}
              voucherCodeDetails={voucherCodeDetails}
              paymentRequest={paymentRequest}
              showBankTransferModal={showBankTransferModal}
              setShowBankTransferModal={setShowBankTransferModal}
              selectedTransaction={selectedTransaction}
              refreshInvestInput={refreshInvestInput}
              setContactUSPop={setContactUSPop}
            />
          </div>
        </div>

        <div className="md:pl-4 mb-4 mt-12">
          <ProjectDescriptionandDoc
            projectDetails={projectDetails}
            projectDetailsLoading={projectDetailsLoading}
            id={id}
            _authUser={_authUser}
          />
        </div>

        <div className="md:pl-4 mb-4 mt-12">
          <OnchainTransactionHistory
            onChainTransactionLists={onChainTransactionLists}
            isPagination={isPagination}
            setPagination={setPagination}
            filterData={filterOnChainData}
            isSortingLoader={isSortingLoader}
            list={onChainTransactionList}
            isListLoader={isOnchainLoader}
            handlePagination={handlePagination}
            slug={'detailsPageOnChainList'}
          />
          <PayoutsTable
            projectDetails={projectDetails}
            isPayoutLoader={isPayoutLoader}
            isSortingLoader={isSortingLoader}
            userPayoutList={userPayoutList}
            receivedPayoutPagination={receivedPayoutPagination}
            handlePagination={handlePagination}
            isPagination={receivedPayoutPagination}
            setPagination={setReceivedPayoutPagination}
            filterData={filterPayoutData}
            list={getUserPayoutList}
          />
        </div>
        {isTransactionPop && (
          <TransactionConfirmationPop
            setTransactionPop={setTransactionPop}
            getProjectsDetails={getProfileDetails}
            paymentStatus={paymentStatus}
            projectDetails={projectDetails}
            paymentSuccessRedirect={paymentSuccessRedirect}
            Navigate={Navigate}
          />
        )}
        {isContactUSPop?.open && (
          <ContactMeModal
            setTransactionPop={setContactUSPop}
            setShowThankYouPopup={setShowThankYouPopup}
            projectDetails={projectDetails}
            paymentStatus={{
              quantity: isContactUSPop?.quantity,
              payment_method: isContactUSPop?.paymentMethod,
            }}
          />
        )}
      </div>
      {showThankYouPopup && (
        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-[24px] p-12 w-[495px] h-[394px] shadow-lg flex flex-col justify-between">
            <div>
              <h2 className="text-2xl font-extralight mb-8">
                {t('contact_confirm_title')}
              </h2>
              <p className="text-base font-bold text-black">
                {t('contact_confirm_message')}
              </p>
            </div>
            <div className="flex justify-end mt-6">
              <button
                onClick={handleCloseThankYouPopup}
                className="bg-[#A7D760] hover:bg-[#97C05B] active:bg-[#8DB158] text-[#0B243F] text-base font-semibold rounded-md transition-all disabled:opacity-50"
              >
                {t('close')}
              </button>
            </div>
          </div>
        </div>
      )}

      {showModalKYC ? (
        <KycVerification
          modelClose={declineModelClose}
          onSuccess={docsignPopOpen}
          nextStep={true}
        />
      ) : null}
      {showPlatformAgreement ? (
        <EsignaturePop
          declineModelClose={declineModelClose}
          type={isAgreementType}
          project_id={id}
          modelClose={modelClose}
          isSignedPltformAgreement={isSignedPltformAgreement}
          setSignedPltformAgreement={setSignedPltformAgreement}
          setIsOpenAggrement={setIsOpenAggrement}
          setIsProjectAgreement={setIsProjectAgreement}
        />
      ) : null}

      {confirmAction && (
        <ConfirmationModal
          firstText={t('bank_info_required')}
          secondText={t('bank_message')}
          successBtnText={t('update')}
          cancelBtnText={t('later')}
          functionCall={addBankDetails}
          closeModal={closeModal}
          setIsOpenAggrement={setIsOpenAggrement}
        />
      )}

      {isWalletExist && (
        <PlatformWalletConnection
          setIsWalletExist={setIsWalletExist}
          paymentRequest={paymentRequest}
        />
      )}

      {showReviewModal && (
        <VerificationFailed
          kycStatus={_authUser.kyc_status}
          reasons={kycFailedReasons}
          setShowModalVerificationStatus={setShowReviewModal}
          kycRejectPop={setShowModalKYC}
        />
      )}
    </>
  );
};

export const NftTransferStatusPopup = ({ onClose }) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  return (
    <>
      <div className="bg-[#ffffdd] border border-[#e9e6b4] py-3 px-4 rounded-xl relative mx-auto mb-4 flex justify-between md:items-center items-start">
        <div className="flex md:items-center items-start">
          <BrownClockRunningIcon />
          <div>
            <p className="font-semibold text-[#625102] md:text-lg text-sm block w-full">
              {t('assets_transfer_in_progress')}
            </p>
            <span className="text-[#7d6e4e] text-xs leading-snug">
              {t('transfer_time_estimate')}
            </span>
          </div>
        </div>
        <button
          onClick={onClose}
          className="flex justify-center items-center  right-0 top-0 p-0"
        >
          <BrownCrossIcon />
        </button>
      </div>
    </>
  );
};

export const TransactionConfirmationPop = ({
  setTransactionPop,
  getProjectsDetails,
  paymentStatus,
  projectDetails,
  paymentSuccessRedirect,
  Navigate,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);

  const paymentMethods = {
    ideal: 'iDeal',
    creditcard: t('credit_card'),
    banktransfer: t('bank_transfer'),
    voucher: 'Voucher',
  };

  return (
    <>
      <div className="fixed w-full h-full flex justify-center items-start py-10 left-0 top-0 z-30 px-4 overflow-y-auto">
        <div className="max-w-xl w-full px-5 pt-10 pb-5 rounded-lg bg-white relative z-40">
          <button
            className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
            onClick={() => {
              setTransactionPop(false);
              getProjectsDetails();
              Navigate('/assets/details/' + paymentStatus?.project_id);
            }}
          >
            <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
              <CloseButtonSvgIcon />
            </span>
          </button>

          {paymentStatus?.status === 'failed' && (
            <div className="flex-column-cente">
              <ImageLoader
                src="/img/failed.gif"
                alt="failed-gif"
                className="mx-auto mb-4"
              />
              <h3 className="text-2xl font-semibold font-suisse mb-4">
                {t('purchase_failed')}
              </h3>
              <h2 className="text-3xl font-bold font-suisse">
                €{paymentStatus?.amount || '0.00'}
              </h2>
            </div>
          )}
          {paymentStatus?.status === 'canceled' && (
            <div className="flex-column-cente">
              <ImageLoader
                src="/img/failed.gif"
                alt="failed-gif"
                className="mx-auto mb-4"
              />
              <h3 className="text-2xl font-semibold font-suisse mb-4">
                {t('purchase_canceled')}
              </h3>
              <h2 className="text-3xl font-bold font-suisse">
                €{paymentStatus?.amount || '0.00'}
              </h2>
            </div>
          )}
          {paymentStatus?.status === 'expired' && (
            <div className="flex-column-cente">
              <ImageLoader
                src="/img/failed.gif"
                alt="failed-gif"
                className="mx-auto mb-4"
              />
              <h3 className="text-2xl font-semibold font-suisse mb-4">
                {t('purchase_expired')}
              </h3>
              <h2 className="text-3xl font-bold font-suisse">
                €{paymentStatus?.amount || '0.00'}
              </h2>
            </div>
          )}
          {paymentStatus?.status === 'completed' && (
            <div className="flex-column-cente">
              <ImageLoader
                src="/img/success.gif"
                alt="success-gif"
                className="mx-auto mb-4"
              />
              <h3 className="text-2xl font-semibold font-suisse mb-4">
                {t('purchase_successful')}
              </h3>
              {paymentStatus?.amount > 0 && (
                <h2 className="text-3xl font-bold font-suisse">
                  €{paymentStatus?.amount || '0.00'}
                </h2>
              )}
            </div>
          )}

          {paymentStatus?.status === 'pending' && (
            <div className="flex-column-cente ">
              <ImageLoader
                src="/img/processing.gif"
                alt="processing-gif"
                className="mx-auto mb-4"
              />
              <h3 className="text-2xl font-semibold font-suisse mb-4">
                {t('transaction_processing')}
              </h3>
              <h2 className="text-3xl font-bold font-suisse">
                €{paymentStatus?.amount || '0.00'}
              </h2>
            </div>
          )}
          <div className="grid sm:grid-cols-2 gap-5 mb-10">
            <div className="">
              <p className="text-sm font-normal text-gray-500 mb-1">
                {t('payment_mode')}
              </p>
              <p className="text-sm font-medium text-black">
                {paymentStatus?.payment_method &&
                  paymentMethods[paymentStatus?.payment_method]}
              </p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-gray-500 mb-1">
                {t('transaction_id')}
              </p>
              <p className="text-sm font-medium text-black">
                {paymentStatus?.transactions_id || 'NA'}
              </p>
            </div>
            <div className="">
              <p className="text-sm font-normal text-gray-500 mb-1">
                {t('payment_date')}
              </p>
              <p className="text-sm font-medium text-black">
                {formatDate(paymentStatus?.created_at, 'DD MMM YYYY HH:mm')}
              </p>
            </div>
          </div>

          {paymentStatus?.status === 'completed' && (
            <div className="bg-white w-full rounded-2xl p-4 shadow-soft border border-gray-100">
              <div className="grid grid-cols-5 gap-5">
                <div className="col-span-2">
                  <ImageLoader
                    alt="big_project_image"
                    src={
                      projectDetails?.project_image
                        ? projectDetails.project_image
                        : '/img/big_project_image.png'
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/img/big_project_image.png';
                    }}
                  />
                </div>
                <div className="col-span-3">
                  <div className="mb-5">
                    <div className="mb-5">
                      <h4 className="text-lg font-semibold">
                        {projectDetails?.name || 'NA'}{' '}
                      </h4>
                      <div className="flex items-center">
                        <LocationIcon />
                        <p className="text-sm text-gray-600">
                          {projectDetails?.location || 'NA'}{' '}
                        </p>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-5 mb-10">
                      <div className="">
                        <p className="text-sm font-normal text-gray-500 mb-1">
                          {t('you_have_received')}
                        </p>
                        <p className="text-xl font-semibold text-black">
                          {paymentStatus?.quantity || 'NA'}{' '}
                          {projectDetails?.investment_type === 'bond'
                            ? `Bond${paymentStatus?.quantity > 1 ? 's' : ''}`
                            : `Token${paymentStatus?.quantity > 1 ? 's' : ''}`}
                        </p>
                      </div>
                    </div>
                    {paymentStatus?.status === 'completed' && (
                      <button
                        onClick={() =>
                          paymentSuccessRedirect(paymentStatus?.project_id)
                        }
                        className="staus-button"
                      >
                        {t('view_project_details')}
                      </button>
                    )}
                    {paymentStatus?.status === 'failed' && (
                      <button className="staus-button">
                        {t('try_repayment')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="opacity-50 fixed w-full h-full left-0 top-0 bg-black"></div>
      </div>
    </>
  );
};

export default ProjectDetails;

const FactsheetComponent = ({
  projectDetails,
  AvailableQty,
  discountAmount,
  formattedPrice,
  setNftBuyErrorMsg,
  NFTquantity,
  isNftQuantity,
  setPaymentMethod,
  isTotalAmount,
  isPaymentMethod,
  isNftBuyErrorMsg,
  haveVoucher,
  setHaveVoucher,
  handleVoucherChange,
  clearVoucher,
  voucherDetailsLoader,
  voucherCode,
  voucherException,
  voucherCodeDetails,
  paymentRequest,
  projectDetailsLoading,
  showBankTransferModal,
  setShowBankTransferModal,
  selectedTransaction,
  refreshInvestInput,
  setContactUSPop,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  const minPurchaseQnty = projectDetails?.min_purchase_qty || 1;

  const closeBankDetailModal = () => {
    setShowBankTransferModal(false);
  };
  return (
    <div className="col-span-12 xl:col-span-4">
      {projectDetailsLoading === true && (
        <div className="col-span-12 xl:col-span-4">
          <FactSheetSkelton />
        </div>
      )}
      {projectDetailsLoading === false && (
        <div className="bg-[#0B243F] text-white rounded-2xl overflow-hidden text-left p-4 h-full">
          <div className="relative">
            <div className="flex gap-4 items-center justify-between">
              <div className="flex gap-4 items-center">
                <h4>{t('factsheet')} </h4>
                {projectDetails?.investment_type === 'bond' ? (
                  <div className="rounded-lg text-sm leading-none font-semibold py-2 px-3 bg-yellow-500 text-brandBlue">
                    {t('common:bond')}
                  </div>
                ) : (
                  <div className="rounded-lg text-sm leading-none font-semibold py-2 px-3 bg-white text-brandBlue ">
                    {t('common:equity')}
                  </div>
                )}
              </div>

              <div>
                {!projectDetails?.is_repaid && AvailableQty === 0 && (
                  <span className="bg-red-500 text-white px-4 py-1 rounded-md font-medium inline-block">
                    {t('sold_out')}
                  </span>
                )}
              </div>
            </div>

            <p className=" border-b-2 border-[#485B6F] text-lg">
              {projectDetails?.investment_type === 'asset'
                ? 'Project'
                : t('issuer')}
            </p>
          </div>
          {projectDetails?.investment_type === 'asset' && (
            <>
              <div className="flex justify-between items-center mt-3 mb-2">
                <div className="font-normal">{t('common:type')}</div>
                <div className="flex items-center font-semibold ">
                  <ImageLoader
                    src={projectDetails?.projectsType?.icon_url}
                    className={
                      projectDetails?.projectsType?.slug === 'wind' ||
                      projectDetails?.projectsType?.slug === 'electric'
                        ? 'dark-patch-icon'
                        : ''
                    }
                    alt=""
                  />
                  {projectDetails?.projectsType?.name}
                </div>
              </div>

              <div className="flex justify-between items-center mt-3 mb-2">
                <p className="font-normal">{t('total_capacity')}</p>
                <div className="flex items-center font-semibold ">
                  {projectDetails?.energy_capacity || 'NA'} MW
                </div>
              </div>
            </>
          )}
          {projectDetails?.investment_type === 'bond' && (
            <>
              <div className="flex justify-between items-center mt-3 mb-2">
                <p className="font-normal">{t('name')}</p>
                <div className="flex items-center font-semibold ">
                  {projectDetails?.issuer_name || 'NA'}
                </div>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('location')}</p>
                <p className="font-semibold">
                  {projectDetails?.location || 'NA'}{' '}
                </p>
              </div>
              {(projectDetails?.inrisc_score ||
                projectDetails?.inrisc_score !== 0) && (
                <div className="flex justify-between items-center mt-2">
                  <div className="flex items-center">
                    <p className="font-normal">{t('inrisc_score')}</p>
                    <QuestInriscSvgIcon />
                    <ReactTooltip
                      id="inrisc-score-tooltip"
                      place="bottom"
                      className="w-16"
                    />
                  </div>
                  <span className="font-semibold flex items-center">
                    <div>{projectDetails?.inrisc_score || 'NA'}</div>
                    <a
                      rel="noreferrer"
                      href={projectDetails?.inrisc_score_link}
                      target="_blank"
                      className="inline-flex items-center font-medium pointer-events-auto"
                    >
                      <OpenNewTabIcon />
                    </a>
                  </span>
                </div>
              )}
            </>
          )}

          <div>
            <p className="mt-3 border-b-2 border-[#485B6F] text-lg">
              {t('offering')}
            </p>
          </div>
          {projectDetails?.isin ? (
            <div className="flex justify-between items-center mt-2">
              <div className="flex items-center">
                <p className="font-normal">ISIN</p>
                <QuestIsinSvgIcon />
                <ReactTooltip
                  id="ISIN-tooltip"
                  place="bottom"
                  className="w-16"
                />
              </div>
              <p className="font-semibold">{projectDetails?.isin}</p>
            </div>
          ) : (
            ''
          )}
          <div className="flex justify-between items-center mt-2">
            <p className="font-normal">{t('common:total_offering')}</p>
            <p className="font-semibold">
              {formatNumber(
                projectDetails?.total_minted *
                  (projectDetails?.nominal_value || 0),
                { decimalPlaces: 2 },
              )}
            </p>
          </div>
          <div className="flex justify-between items-center mt-2">
            <div className="flex items-center">
              <p className="font-normal">{t('common:nominal_value')}</p>
              <QuestNominalSvgIcon />
              <ReactTooltip
                id="nominal-value-tooltip"
                place="bottom"
                className="w-16"
              />
            </div>
            <p className="font-semibold flex items-center">
              {formatNumber(projectDetails?.nominal_value, {
                minimumFractionDigits: 2,
              })}{' '}
            </p>
          </div>

          {projectDetails?.price > 0 && (
            <div className="flex justify-between items-center mt-2">
              <div className="flex items-center">
                <p className="font-normal">{t('common:price')}</p>
                <QuestPriceSvgIcon />
                <ReactTooltip
                  id="price-tooltip"
                  place="bottom"
                  className="w-16"
                />
              </div>
              <p className="font-semibold flex items-center">
                {formatNumber(formattedPrice, {
                  minimumFractionDigits: 2,
                })}
              </p>
            </div>
          )}

          {projectDetails?.investment_type === 'bond' && (
            <>
              <div className="flex justify-between items-center mt-2">
                <div className="flex items-center">
                  <p className="font-normal">{t('annual_interest_rate')}</p>
                  <QuestAnnualInterestSvgIcon />
                  <ReactTooltip
                    id="annual-interest-tooltip"
                    place="bottom"
                    className="w-16"
                  />
                </div>
                <p className="font-semibold flex items-center">
                  {projectDetails?.interest_rate}%
                </p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <div className="flex items-center">
                  <p className="font-normal">{t('common:annual_yield')}</p>
                  <QuestAnnualYieldSvgIcon />
                  <ReactTooltip
                    id="annual-yield-tooltip"
                    place="bottom"
                    className="w-16"
                  />
                </div>
                <p className="font-semibold flex items-center">
                  {projectDetails?.expected_apy || 'NA'}%
                </p>
              </div>
              <div className="flex justify-between items-center mt-2">
                <div className="flex items-center">
                  <p className="font-normal">{t('repayment_type')}</p>
                  <QuestRepaymentSvgIcon />
                  <ReactTooltip
                    id="repayment-type-tooltip"
                    place="bottom"
                    className="w-16"
                  />
                </div>
                <p className="font-semibold flex items-center">{t('bullet')}</p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('payout_schedule')}</p>
                <p className="font-semibold capitalize">
                  {projectDetails?.payout_cycle}
                </p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('common:maturity_date')}</p>
                <p className="font-semibold">
                  {formatDate(projectDetails?.maturity_date, 'DD MMM YYYY')}
                </p>
              </div>
            </>
          )}
          {projectDetails?.investment_type === 'asset' && (
            <>
              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('expected_apy')}</p>
                <p className="font-semibold">
                  {projectDetails?.expected_apy || 'NA'} %
                </p>
              </div>
              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('common:remaining_lifetime')}</p>
                <p className="font-semibold">
                  {calculateLifeSpanDifference(projectDetails?.life_span_to)}{' '}
                  {t('common:years_left')}
                </p>
              </div>
              <div className="flex justify-between items-center mt-2">
                <p className="font-normal">{t('common:lifespan')}</p>
                <p className="font-semibold">
                  {formatDate(
                    projectDetails?.life_span_from,
                    'YYYY',
                    'NA',
                    projectDetails?.life_span_to,
                  )}
                </p>
              </div>
              {(projectDetails?.inrisc_score ||
                projectDetails?.inrisc_score !== 0) && (
                <div className="flex justify-between items-center mt-2">
                  <div className="flex items-center">
                    <p className="font-normal">{t('inrisc_score')}</p>
                    <QuestInriscSvgIcon />
                    <ReactTooltip
                      id="inrisc-score-tooltip"
                      place="bottom"
                      className="w-16"
                    />
                  </div>
                  <div className="font-semibold flex items-center">
                    <span>{projectDetails?.inrisc_score || 'NA'}</span>
                    <a
                      rel="noreferrer"
                      href={projectDetails?.inrisc_score_link}
                      target="_blank"
                      className="inline-flex items-center font-medium pointer-events-auto"
                    >
                      <OpenNewTabIcon />
                    </a>
                  </div>
                </div>
              )}
            </>
          )}

          <div>
            <p className="mt-3 border-b-2 border-[#485B6F] text-lg">
              Blockchain
            </p>
          </div>

          <div className="flex justify-between items-center mt-3 mb-2">
            <p className="font-normal">{t('common:ticker')}</p>
            <a
              target="_blank"
              href={projectDetails?.tokensExplorerUrl}
              rel="noreferrer"
              className="inline-flex font-semibold items-right"
            >
              {projectDetails?.symbol || 'NA'}
              <OpenNewTabIcon />
            </a>
          </div>
          <div className="flex justify-between items-center mt-2">
            <p className="font-normal">{t('common:type')}</p>
            <p className="font-semibold">
              {projectDetails?.token_standard || 'NA'}
            </p>
          </div>
          <div className="flex justify-between items-center mt-2">
            <p className="font-normal">{t('common:chain')}</p>
            <p className="font-semibold">
              {projectDetails?.chain_name?.toUpperCase() || 'NA'}
            </p>
          </div>
          <div>
            <p className="mt-3 border-b-2 border-[#485B6F] text-lg mb-4">
              {t('invest_now')}
            </p>
          </div>

          {projectDetails?.is_repaid ? (
            <button className="bg-GreenColor w-full text-black  cursor-not-allowed text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center active:bg-[#8DB158] hover:transition-all mt-4">
              {t('common:repaid')}
            </button>
          ) : (
            projectDetails?.transfer_freezed === false &&
            projectDetails?.project_status === 1 && (
              <>
                <div className="grid gap-x-4 grid-cols-2">
                  {AvailableQty > 0 && (
                    <>
                      <div>
                        <div className="bg-white flex item-center rounded-md overflow-hidden">
                          <input
                            placeholder="0"
                            type="number"
                            onInput={(e) => {
                              setNftBuyErrorMsg(null);
                              NFTquantity(e.target.value);
                            }}
                            value={isNftQuantity || ''}
                            min="1"
                            className="border-none px-4 text-left text-black h-12 appearance-none"
                          />

                          <div className=" min-w[50px] border-l-2 bg-white text-[#0B243F] text-sm leading-normal py-3 px-3 lg:px-2">
                            {projectDetails?.investment_type === 'bond'
                              ? t('projectDetails:bonds')
                              : t('projectDetails:equity')}
                          </div>
                        </div>
                      </div>

                      <div>
                        <>
                          <div className="w-full cursor-not-allowed">
                            {projectDetails?.professional_investors_only ? (
                              <select
                                name="paymentMethod"
                                id="paymentMethod"
                                disabled
                                className="py-3 px-4 text-sm leading-normal h-12 text-gray-900 border border-gray-300 rounded-md bg-gray-50 w-full"
                                value="banktransfer"
                              >
                                <option value="banktransfer">
                                  {t('bank_transfer')}
                                </option>
                              </select>
                            ) : (
                              <select
                                name="paymentMethod"
                                id="paymentMethod"
                                onChange={(e) => {
                                  setNftBuyErrorMsg(null);
                                  setPaymentMethod(e.target.value);
                                }}
                                disabled={
                                  !(
                                    isTotalAmount - discountAmount > 0 &&
                                    isTotalAmount
                                  ) && isNftQuantity !== 0
                                }
                                value={
                                  !(
                                    isTotalAmount - discountAmount > 0 &&
                                    isTotalAmount
                                  )
                                    ? ''
                                    : isPaymentMethod
                                }
                                className={`inline-block ${
                                  !(
                                    isTotalAmount - discountAmount > 0 &&
                                    isTotalAmount
                                  ) && isNftQuantity !== 0
                                    ? 'cursor-not-allowed'
                                    : ''
                                } py-3 px-4 text-sm leading-normal h-12 text-gray-900 border border-gray-300 rounded-md bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 w-full`}
                              >
                                <option value="">{t('select_payment')}</option>
                                <option value="ideal">iDeal</option>
                                <option value="banktransfer">
                                  {t('bank_transfer')}
                                </option>
                              </select>
                            )}
                          </div>
                        </>
                      </div>
                      <div className="col-span-2 mt-1">
                        {isNftBuyErrorMsg && (
                          <div className="text-red-500 text-sm text-left mb-1">
                            {isNftBuyErrorMsg || 'NA'}
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>

                {!haveVoucher && AvailableQty > 0 && (
                  <div className="pb-3 mt-0">
                    <p
                      className="text-sm font-medium pb-1 border-b border-white inline-block cursor-pointer"
                      onClick={() => {
                        setHaveVoucher(true);
                        setNftBuyErrorMsg('');
                      }}
                    >
                      {t('have_voucher')}
                    </p>
                  </div>
                )}

                {haveVoucher && AvailableQty > 0 && (
                  <div className="w-full mt-1 py-1">
                    <div className="gap-x-4 flex ">
                      <div className="w-full ">
                        <div>
                          <div className="relative">
                            <input
                              placeholder="Voucher Code"
                              value={voucherCode}
                              onChange={(e) => {
                                handleVoucherChange(e.target.value);
                              }}
                              className="border-none pl-4 pr-12 bg-white text-left text-black h-12 appearance-none w-full"
                            />
                          </div>
                        </div>

                        {!voucherDetailsLoader ? (
                          <p className="text-red-500 text-sm leading-tight mt-2">
                            {voucherException}
                          </p>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="flex gap-x-3">
                        <button
                          className="bg-[#A19785] text-[#002541] text-lg font-semibold rounded-md px-4 h-12 leading-normal py-2 flex flex-col justify-center items-center hover:bg-[#A19785] focus:bg-[#A19785] active:bg-[#A19785] hover:transition-all"
                          onClick={() => clearVoucher()}
                        >
                          {t('common:cancel')}
                        </button>
                      </div>
                    </div>
                    {!voucherDetailsLoader ? (
                      voucherCode?.length > 0 &&
                      !voucherException && (
                        <div>
                          <div className="w-full pb-1">
                            <div className="flex align-items-center justify-between ">
                              <p className="text-white-500 text-sm">
                                {isNftQuantity === 0 &&
                                voucherCodeDetails &&
                                voucherCodeDetails?.totalRemainToken > 0
                                  ? `${t('projectDetails:voucher_valid_for')}
                                        ${voucherCodeDetails?.totalRemainToken}
                                      ${
                                        projectDetails?.investment_type ===
                                        'bond'
                                          ? t('projectDetails:bonds')
                                          : t('projectDetails:tokens')
                                      },
                            ${t('projectDetails:please_choose_amount')} `
                                  : voucherCodeDetails &&
                                    `${t('projectDetails:voucher_applied_for')}
                              ${
                                voucherCodeDetails?.totalRemainToken >
                                isNftQuantity
                                  ? isNftQuantity
                                  : voucherCodeDetails.totalRemainToken
                              }
                        ${
                          projectDetails?.investment_type === 'bond'
                            ? t('projectDetails:bonds')
                            : t('projectDetails:tokens')
                        }.`}
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      <>
                        <div className="loader-dots mt-1"></div>
                      </>
                    )}
                  </div>
                )}

                {!projectDetails?.professional_investors_only ? (
                  <>
                    {AvailableQty > 0 && (
                      <>
                        <button
                          onClick={() => {
                            paymentRequest();
                          }}
                          className={
                            isNftBuyErrorMsg || voucherException
                              ? 'bg-[#787a7d] w-full text-[#0B243F] cursor-not-allowed text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center hover:bg-[#787a7d] focus:bg-[#787a7d] active:bg-[#787a7d] hover:transition-all clear-both'
                              : 'bg-[#A7D760] w-full text-[#0B243F] text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all clear-both'
                          }
                          disabled={isNftBuyErrorMsg || voucherException}
                        >
                          {projectDetails?.user_total_quantity > 0
                            ? isTotalAmount - discountAmount === 0 &&
                              haveVoucher &&
                              voucherCodeDetails &&
                              !voucherException
                              ? t('pay_using_voucher')
                              : isTotalAmount - discountAmount > 0 &&
                                  haveVoucher &&
                                  !voucherException &&
                                  voucherCodeDetails &&
                                  isNftQuantity !== 0
                                ? `${t('pay_remaining')} ${formatNumber(
                                    isTotalAmount - discountAmount,
                                  )}`
                                : t('buy_more')
                            : isTotalAmount - discountAmount === 0 &&
                                haveVoucher &&
                                !voucherException &&
                                voucherCodeDetails
                              ? t('pay_using_voucher')
                              : isTotalAmount - discountAmount > 0 &&
                                  haveVoucher &&
                                  voucherCodeDetails &&
                                  !voucherException &&
                                  isNftQuantity !== 0
                                ? `${t('pay_remaining')} ${formatNumber(
                                    isTotalAmount - discountAmount,
                                  )}`
                                : t('purchase')}
                        </button>

                        <p className="font-normal text-xs text-gray-400 mt-3">
                          {t('min_purchase')}{' '}
                          {projectDetails?.investment_type === 'bond' &&
                          !projectDetails?.hasPreviousInvestments
                            ? `${minPurchaseQnty}`
                            : '1'}
                          {projectDetails?.investment_type === 'bond'
                            ? ' bond'
                            : ' token'}
                        </p>
                      </>
                    )}

                    {AvailableQty === 0 &&
                      projectDetails?.project_status === 1 && (
                        <>
                          <button className="bg-red-500 w-full text-white cursor-not-allowed text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center active:bg-[#8DB158] hover:transition-all mt-4">
                            {t('sold_out')}
                          </button>
                        </>
                      )}
                  </>
                ) : (
                  <div className="mt-1">
                    <button
                      onClick={() =>
                        setContactUSPop({
                          open: true,
                          quantity: isNftQuantity,
                          paymentMethod: isPaymentMethod,
                        })
                      }
                      className="bg-[#A7D760] w-full text-[#0B243F] text-lg font-semibold rounded-md px-5 py-3 flex justify-center items-center hover:bg-[#97C05B]"
                    >
                      {t('invest')}
                    </button>
                  </div>
                )}
              </>
            )
          )}
          {(projectDetails?.project_status === 0 ||
            projectDetails?.transfer_freezed === true) && (
            <div className="w-full p-4 bg-white text-center text-white font-semibold mt-4 rounded-xl bg-opacity-20">
              <p>{t('project_not_available')}</p>
            </div>
          )}
          {showBankTransferModal && (
            <BankTransferModal
              closeModal={closeBankDetailModal}
              selectedTransaction={selectedTransaction}
              refreshInvestInput={refreshInvestInput}
            />
          )}
        </div>
      )}
    </div>
  );
};

export const FactSheetSkelton = () => {
  return (
    <>
      <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
        <div className="p-4  bg-gray-50 rounded-xl">
          <Skeleton count={1} height={40} className="mb-3" />
          <Skeleton count={1} height={20} />

          <div className="grid grid-cols-2 gap-4 mt-4 mb-4">
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={150} />
            <Skeleton count={1} height={25} className="" width={80} />
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={60} />
            <Skeleton count={1} height={25} className="" width={90} />
          </div>

          <Skeleton count={1} height={30} className="mb-3" />
          <Skeleton count={1} height={20} />

          <div className="grid grid-cols-2 gap-4 mt-4 mb-4">
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={150} />
            <Skeleton count={1} height={25} className="" width={80} />
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={60} />
            <Skeleton count={1} height={25} className="" width={90} />
          </div>

          <Skeleton count={1} height={20} />

          <div className="grid grid-cols-2 gap-4 mt-4 mb-4">
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={150} />
            <Skeleton count={1} height={25} className="" width={80} />
            <Skeleton count={1} height={25} className="" width={100} />
            <Skeleton count={1} height={25} className="" width={60} />
            <Skeleton count={1} height={25} className="" width={90} />
          </div>
        </div>
      </SkeletonTheme>
    </>
  );
};

const ProjectInfo = ({
  projectDetailsLoading,
  projectDetails,
  AvailableQty,
  Navigate,
  isTotalPaidDividendAmount,
  language,
}) => {
  return (
    <div className="col-span-12 xl:col-span-8">
      {projectDetailsLoading === false && (
        <div
          className={
            projectDetails?.projectsType?.slug === 'wind' ||
            projectDetails?.projectsType?.slug === 'electric'
              ? 'bg-[#' +
                projectDetails?.projectsType?.color_code +
                '] rounded-2xl flex items-start px-4 py-4 text-white'
              : 'bg-[#' +
                projectDetails?.projectsType?.color_code +
                '] rounded-2xl flex items-start px-4 py-4 text-black'
          }
        >
          <div
            onClick={() => Navigate('/assets')}
            className=" block mr-6 mt-2 cursor-pointer  dark:text-slate-200"
          >
            <LeftArrowIcon />
          </div>
          <div>
            <h3 className="font-semibold leading-normal capitalize  dark:text-slate-200">
              {projectDetails?.name || 'NA'}{' '}
            </h3>
            <div className="mr-1 font-normal text-base inline-flex items-center   dark:text-slate-200">
              <LocationIcon />

              {projectDetails?.location || 'NA'}
            </div>
          </div>
        </div>
      )}
      {projectDetailsLoading === true && (
        <div className="">
          <div className="mb-4">
            <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
              <div className="p-4  bg-gray-50 rounded-xl">
                <Skeleton count={1} height={40} className="mb-3" />
                <Skeleton count={1} height={20} />
              </div>
            </SkeletonTheme>
          </div>

          <SkeletonTheme baseColor="#ECECEC" highlightColor="#ffffff">
            <div className="p-4  bg-gray-50 rounded-xl">
              <Skeleton count={1} height={400} className="" />
              <Skeleton count={1} height={20} />
            </div>
          </SkeletonTheme>
        </div>
      )}

      {projectDetailsLoading === false && (
        <div className="mt-4  relative sliderownr lg:h-[670px]">
          <Sliderify autoPlay={false} showSpot={false} showNavDots={false}>
            <div className="h-[350px] lg:h-full relative">
              <ImageLoader
                src={
                  projectDetails?.project_image
                    ? projectDetails.project_image
                    : '/img/big_project_image.png'
                }
                alt="project-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/img/big_project_image.png';
                }}
                className="object-cover w-full h-full rounded-2xl"
              />

              {projectDetails?.investment_type === 'bond' &&
              projectDetails?.is_repaid ? (
                <RepaidListingSvgIcon language={language} />
              ) : AvailableQty === 0 ? (
                language === 'en' ? (
                  <SoldOutSvgIcon />
                ) : (
                  <SoldOutDutchSvgIcon />
                )
              ) : (
                ''
              )}
            </div>
            {projectDetails &&
              projectDetails?.projectImages?.length > 0 &&
              projectDetails?.projectImages.map((images, index) => {
                return (
                  <div key={index} className="h-[350px] lg:h-[550px]">
                    <ImageLoader
                      src={
                        images?.resourceUrl
                          ? images.resourceUrl
                          : '/img/big_project_image.png'
                      }
                      alt="project-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/img/big_project_image.png';
                      }}
                      className="object-cover w-full h-full max-h-[600px] rounded-2xl"
                    />
                    {AvailableQty === 0 ? (
                      language === 'en' ? (
                        <SoldOutSvgIcon />
                      ) : (
                        <SoldOutDutchSvgIcon />
                      )
                    ) : (
                      ''
                    )}
                  </div>
                );
              })}
          </Sliderify>
          <div className=" lg:absolute lg:bottom-4 w-full lg:grid lg:gap-4 lg:grid-cols-2 lg:px-4">
            <ProjectPricingDetails
              projectDetails={projectDetails}
              AvailableQty={AvailableQty}
            />
            <ProjectOwnAssetDetails
              projectDetails={projectDetails}
              isTotalPaidDividendAmount={isTotalPaidDividendAmount}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export const ProjectOwnAssetDetails = ({
  projectDetails,
  isTotalPaidDividendAmount,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  return (
    <>
      <div className="bg-gray-100 mt-2 md:mt-0 md:bg-white dark:bg-slate-800 md:dark:bg-slate-800 dark:text-slate-200 rounded-lg p-4">
        <div className="flex justify-between items-center mb-2">
          <p className="font-normal">
            {t('your')}{' '}
            <a
              target="_blank"
              href={projectDetails?.tokensExplorerUrl}
              rel="noreferrer"
            >
              <span className="text-[#E79853]">
                {' '}
                {projectDetails?.symbol || 'NA'}
              </span>{' '}
            </a>
            {t('holdings')}
          </p>
          <div className="font-semibold ">
            {' '}
            {Number(projectDetails?.user_total_quantity) || '0'}{' '}
          </div>
        </div>
        <div className="flex justify-between items-center mb-2 ">
          <p className="font-normal">{t('total_amount_invested')}</p>
          <div className="font-semibold ">
            {' '}
            {formatNumber(projectDetails?.user_invested_amount, {
              decimalPlaces: 2,
            })}{' '}
          </div>
        </div>
        <div className="flex justify-between items-center ">
          <p className="font-normal">
            {projectDetails?.investment_type === 'bond'
              ? t('my_received_interest')
              : t('total_payouts_received')}
          </p>
          <div className="font-semibold ">
            {' '}
            {formatNumber(isTotalPaidDividendAmount, {
              decimalPlaces: 2,
            })}{' '}
          </div>
        </div>
      </div>
    </>
  );
};

export const ProjectPricingDetails = ({ projectDetails, AvailableQty }) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  return (
    <>
      <div className="bg-gray-100 mt-2 md:mt-0 md:bg-white dark:bg-slate-800 md:dark:bg-slate-800 dark:text-slate-200 rounded-lg p-4">
        <div className="flex justify-between items-center mb-2 ">
          <p className="font-normal">
            {projectDetails?.investment_type === 'bond'
              ? t('amount_of_bond')
              : t('amount_of__token')}
          </p>
          <div className="flex items-center">
            <span className="font-semibold">{AvailableQty || '0'}</span> /{' '}
            <span className="text-[#85919F] font-semibold">
              {projectDetails?.total_minted || '00'}
            </span>
          </div>
        </div>
        {projectDetails?.investment_type === 'asset' && (
          <div className="flex justify-between items-center mb-2">
            <p className="font-normal">{t('power_per_token')}</p>
            <div className="font-semibold ">
              {' '}
              {calculateEnergyCapacity(
                projectDetails?.energy_capacity,
                projectDetails?.available_for_sale,
              )}{' '}
              {t('common:watt_peak')}{' '}
            </div>
          </div>
        )}
        {projectDetails?.investment_type === 'bond' && (
          <div className="flex justify-between items-center mb-2">
            <p className="font-normal">{t('annual_interest_rate')}</p>
            <div className="font-semibold ">
              {' '}
              {projectDetails?.interest_rate}%{' '}
            </div>
          </div>
        )}

        {projectDetails?.price === 0 ? (
          <div className="flex justify-between items-center ">
            <p className="font-normal">t{'common:nominal_value'}</p>

            <div className="font-semibold ">
              {' '}
              {formatNumber(Number(projectDetails?.nominal_value), {
                decimalPlaces: 2,
              })}{' '}
            </div>
          </div>
        ) : (
          <div className="flex justify-between items-center mt-2">
            <p className="font-normal">{t('common:price')}</p>

            <div className="font-semibold ">
              {' '}
              {formatNumber(Number(projectDetails?.price), {
                decimalPlaces: 2,
              })}{' '}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const ProjectDescriptionandDoc = ({
  projectDetails,
  projectDetailsLoading,
  id,
  _authUser,
}) => {
  const language = useSelector((state) => state.languageReducer.language);
  const { t } = useTranslation(['projectDetails', 'common']);
  return (
    <div className=" bg-gray-100 dark:bg-slate-800 dark:text-slate-200 rounded-md p-5">
      <div className="lg:grid lg:gap-12 lg:grid-cols-12 ">
        {projectDetailsLoading === false && (
          <div className="col-span-12 lg:col-span-6">
            <div className="border-b-2 mt-4">
              <h3 className="font-medium ">{projectDetails?.name || 'NA'}</h3>
            </div>
            <div>
              <div className="text-sm mt-4 leading-normal">
                <div data-color-mode="" className="theme-color">
                  <div className="wmde-markdown-var"> </div>
                  <MDEditor.Markdown
                    source={
                      language === 'nl' && projectDetails?.description_dutch
                        ? projectDetails?.description_dutch
                        : projectDetails?.description || 'NA'
                    }
                    style={{ background: 'none' }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {projectDetailsLoading === true && (
          <div className="col-span-12 lg:col-span-6">
            <SkeletonTheme baseColor="#ffffff" highlightColor="#f5f5f5">
              <div className="w-2/3">
                <Skeleton count={1} height={40} className="mb-3" />
              </div>
              <Skeleton count={1} height={20} className="mb-2" />
              <Skeleton count={1} height={20} className="mb-2" />
              <Skeleton count={1} height={20} className="mb-2" />
            </SkeletonTheme>
          </div>
        )}
        {projectDetailsLoading === true && (
          <>
            <SkeletonTheme baseColor="#ffffff" highlightColor="#f5f5f5">
              <div className="col-span-12 lg:col-span-6">
                <div className="relative pr-40 border border-gray-100 pb-2 rounded-md mb-2">
                  <div className="flex items-center gap-4 relative top-[2px] pl-2">
                    <div>
                      <Skeleton count={1} width={20} height={20} />
                    </div>
                    <p className="truncate w-full">
                      <Skeleton className="w-full" count={1} height={22} />
                    </p>
                  </div>
                  <a
                    href={document.resourceUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="w-32 absolute right-2 top-0 px-2 py-1 rounded-sm text-sm"
                  >
                    <Skeleton count={1} height={20} />
                  </a>
                </div>
                <div className="relative pr-40 border border-gray-100 pb-2 rounded-md mb-2">
                  <div className="flex items-center gap-4 relative top-[2px] pl-2">
                    <div>
                      <Skeleton count={1} width={20} height={20} />
                    </div>
                    <p className="truncate w-full">
                      <Skeleton className="w-full" count={1} height={22} />
                    </p>
                  </div>
                  <a
                    href={document.resourceUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="w-32 absolute right-2 top-0 px-2 py-1 rounded-sm text-sm"
                  >
                    <Skeleton count={1} height={20} />
                  </a>
                </div>
                <div className="relative pr-40 border border-gray-100 pb-2 rounded-md mb-2">
                  <div className="flex items-center gap-4 relative top-[2px] pl-2">
                    <div>
                      <Skeleton count={1} width={20} height={20} />
                    </div>
                    <p className="truncate w-full">
                      <Skeleton className="w-full" count={1} height={22} />
                    </p>
                  </div>
                  <a
                    href={document.resourceUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="w-32 absolute right-2 top-0 px-2 py-1 rounded-sm text-sm"
                  >
                    <Skeleton count={1} height={20} />
                  </a>
                </div>
                <div className="mt-6 relative ">
                  <div className="absolute left-0 top-0 bottom-0 my-auto h-[80%]">
                    <Skeleton
                      count={1}
                      className="rounded-md h-full"
                      width={2}
                    />
                  </div>
                  <div className="relative pl-8 sm:pl-8 py-2 group">
                    <div className="absolute -left-1 top-4">
                      <Skeleton
                        count={1}
                        width={12}
                        height={12}
                        borderRadius={40}
                        className="border-2 border-white"
                      />
                    </div>
                    <Skeleton
                      count={1}
                      height={32}
                      className="rounded-md"
                      width={180}
                    />
                  </div>

                  <div className="relative pl-8 sm:pl-8 py-2 group">
                    <div className="absolute -left-1 top-4">
                      <Skeleton
                        count={1}
                        width={12}
                        height={12}
                        borderRadius={40}
                        className="border-2 border-white"
                      />
                    </div>
                    <Skeleton
                      count={1}
                      height={32}
                      className="rounded-md"
                      width={180}
                    />
                  </div>

                  <div className="relative pl-8 sm:pl-8 py-2 group">
                    <div className="absolute -left-1 top-4">
                      <Skeleton
                        count={1}
                        width={12}
                        height={12}
                        borderRadius={40}
                        className="border-2 border-white"
                      />
                    </div>
                    <Skeleton
                      count={1}
                      height={32}
                      className="rounded-md"
                      width={180}
                    />
                  </div>
                  <div className="relative pl-8 sm:pl-8 group">
                    <Skeleton
                      count={1}
                      height={32}
                      className="rounded-md"
                      width={60}
                    />
                  </div>

                  <div className="relative pl-8 sm:pl-8 py-2 group">
                    <div className="absolute -left-1 top-4">
                      <Skeleton
                        count={1}
                        width={12}
                        height={12}
                        borderRadius={40}
                        className="border-2 border-white"
                      />
                    </div>
                    <Skeleton
                      count={1}
                      height={32}
                      className="rounded-md"
                      width={180}
                    />
                  </div>
                </div>
              </div>
            </SkeletonTheme>
          </>
        )}

        {projectDetailsLoading === false && (
          <div className="col-span-12 lg:col-span-6 mt-4">
            <div className="border-b-2">
              <h3 className="font-medium ">{t('documents')} </h3>
            </div>
            <div className=" mb-5 bg-white dark:bg-slate-800 my-4">
              <div className="overflow-auto">
                {projectDetails &&
                projectDetails?.projectDocument?.length > 0 ? (
                  projectDetails?.projectDocument.map((document, index) => {
                    return (
                      <div
                        key={index}
                        className="relative pr-40 border-b border-gray-100 p-2 pb-2"
                      >
                        <div className="flex items-center gap-4 relative top-0">
                          <div>
                            <ImageLoader
                              src="/img/PDF-Icon.png"
                              className="max-w-[18px]"
                              alt=""
                            />
                          </div>
                          <p className="truncate dark:text-slate-200">
                            {formatWithEllipsis(document?.name, 80)}
                          </p>
                        </div>
                        <a
                          href={document.resourceUrl}
                          target="_blank"
                          rel="noreferrer"
                          className="absolute right-2 top-[6px] flex gap-2 items-center bg-GreenColor text-brandBlue px-2 py-1 rounded-sm text-sm"
                        >
                          <DownloadSvgIcon /> {t('download')}
                        </a>
                      </div>
                    );
                  })
                ) : (
                  <div className="flex items-center font-normal flex-wrap gap-4 my-4 mx-2">
                    <p>
                      <b>{t('project_documents_unavailable')}</b>
                    </p>
                  </div>
                )}
              </div>
            </div>
            {projectDetails?.investment_type === 'bond' ? (
              <UpcomingPayoutList id={id} userId={_authUser.userId} />
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const OnchainTransactionHistory = ({
  onChainTransactionLists,
  list,
  isPagination,
  isSortingLoader,
  setPagination,
  filterData,
  isListLoader,
  slug,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  const [isOnChangeHeaderList, setOnChangeHeaderList] = useState([]);

  useEffect(() => {
    const headers = [
      { Name: t('common:date') },
      { Name: 'TYPE' },
      { Name: t('common:from') },
      { Name: t('common:to') },
      { Name: 'TOKENS' },
      { Name: 'LINK' },
    ];

    if (slug === 'dashboard') {
      headers.unshift({ Name: 'Project Name' });
    } else {
      headers.splice(5, 0, { Name: 'status' });
    }

    setOnChangeHeaderList(headers);
  }, [t]);

  return (
    <div className="">
      <div className="">
        <h3 className="pb-2 mb-2  border-b mt-4 border-[#B6BDC5] dark:border-slate-400 dark:text-slate-200">
          {t('onchain_transaction_history')}
        </h3>
        <p className="dark:text-slate-200 ml-2">
          {slug === 'dashboard'
            ? t('all_transactions')
            : t('all_transactions_for_project')}
        </p>
      </div>

      {onChainTransactionLists && onChainTransactionLists?.length > 0 && (
        <div className="p-2 relative sm:rounded-lg  bg-[#F3F3F3] dark:bg-slate-800 mt-5">
          <div className="relative overflow-x-auto max-w-3xl xl:max-w-full  sm:rounded-lg w-full">
            <TableComponent
              headerList={isOnChangeHeaderList}
              isSortingLoader={isSortingLoader}
              isList={onChainTransactionLists}
              columnCount={9}
              rowCount={6}
              fetchData={list}
              pagination={isPagination}
              setPagination={setPagination}
              filterData={filterData}
              isListLoader={isListLoader}
              slug={'detailsPageOnChainList'}
            />
          </div>
        </div>
      )}
      {onChainTransactionLists && onChainTransactionLists?.length === 0 && (
        <div className="my-6">
          <div className="mx-auto text-center">
            <ImageLoader
              src="/img/performedanytransaction.png"
              className="inline-block mb-4 max-w-[180px]"
              alt="performTransaction"
            />
          </div>
          <div className="text-center text-xl font-semibold text-brandBlue dark:text-slate-200 mb-3">
            {t('transaction_not_available')}
          </div>
        </div>
      )}
    </div>
  );
};

const PayoutsTable = ({
  projectDetails,
  isPayoutLoader,
  userPayoutList,
  isSortingLoader,
  isPagination,
  setPagination,
  filterData,
  list,
}) => {
  const { t } = useTranslation(['projectDetails', 'common']);
  const [isPayoutListHeader, setPayoutListHeader] = useState([]);

  useEffect(() => {
    setPayoutListHeader([
      { Name: 'status' },
      { Name: t('common:amount') },
      { Name: t('period') },
    ]);
  }, [t]);
  return (
    <div className="mt-12">
      <div className="pb-4">
        <h3 className="pb-2 mb-2 border-b border-[#B6BDC5] dark:border-slate-400 dark:text-slate-200">
          {projectDetails?.investment_type === 'asset'
            ? t('my_received_dividends')
            : t('my_received_interest')}
        </h3>
      </div>

      <div className="relative overflow-x-auto  sm:rounded-lg">
        <TableComponent
          headerList={isPayoutListHeader}
          isListLoader={isPayoutLoader}
          isSortingLoader={isSortingLoader}
          isList={userPayoutList}
          columnCount={4}
          rowCount={6}
          slug={'payoutList'}
          fetchData={list}
          pagination={isPagination}
          setPagination={setPagination}
          filterData={filterData}
        />
      </div>
      {userPayoutList?.length === 0 && isPayoutLoader === false && (
        <div className="my-6">
          <div className="mx-auto text-center">
            <ImageLoader
              src="/img/performedanytransaction.png"
              className="inline-block mb-4 max-w-[180px]"
              alt="transaction"
            />
          </div>
          <div className="text-center text-xl font-semibold text-brandBlue dark:text-slate-200 mb-3">
            {projectDetails?.investment_type === 'asset'
              ? t('you_have_not_received_any_dividend_yet')
              : t('you_have_not_received_any_interest_yet')}
          </div>
        </div>
      )}
    </div>
  );
};
